import { Component, computed, inject, input } from '@angular/core';
import { rxResourceFixed } from '@zayan-erp/shared';
import { of } from 'rxjs';
import { SalesService } from '../../../services/sales.service';
import { LinkedCoBuyerLotWithDetails } from '../../../models/linked-co-buyer.models';
import { AvailableCoBuyersSidebarComponent } from './available-co-buyers-sidebar/available-co-buyers-sidebar.component';
import { LinkedCoBuyersTableComponent } from './linked-co-buyers-table/linked-co-buyers-table.component';
import { SalesApsService } from '../../../services/sales-aps.service';
@Component({
  selector: 'deal-co-buyers-link',
  imports: [AvailableCoBuyersSidebarComponent, LinkedCoBuyersTableComponent],
  templateUrl: './deal-co-buyers-link.component.html'
})
export class DealCoBuyersLinkComponent {
  readonly #salesService = inject(SalesService);
  readonly #salesApsService = inject(SalesApsService);

  readonly prospectId = input<string | null>();
  readonly lotId = input<string | null>(null);
  readonly isActive = input<boolean>(true);
  readonly dealId = input<string>('');
  // Centralized linked co-buyers resource - single source of truth

  effectiveDeal = computed(() => this.#salesApsService.currentDeal());
  effectiveDealId = computed(() => this.effectiveDeal()?.id ?? '');
  effectiveProspectId = computed(
    () =>
      this.prospectId() ??
      this.effectiveDeal()?.prospect?.id ??
      (this.effectiveDeal() as { prospectId?: string } | undefined)?.prospectId ??
      null
  );
  effectiveLotId = computed(() => this.lotId() ?? this.effectiveDeal()?.lot.id ?? null);

  readonly linkedCoBuyerIds = computed(
    () => new Set((this.linkedCoBuyersResource.value() ?? []).map(linked => linked.coBuyerId))
  );

  onCoBuyerLinked(): void {
    this.linkedCoBuyersResource.reload();
  }

  readonly linkedCoBuyersResource = rxResourceFixed<
    LinkedCoBuyerLotWithDetails[],
    { isActive: boolean; dealId: string }
  >({
    params: () => ({ isActive: this.isActive(), dealId: this.effectiveDealId() }),
    defaultValue: [] as LinkedCoBuyerLotWithDetails[],
    stream: ({ params }) =>
      !params.isActive && params.dealId ? this.#salesService.readLinkedCoBuyersByDeadId(params.dealId) : of([])
  });
}
